/* eslint-disable jsx-a11y/no-redundant-roles */
import {
  HomeIcon,
  UserCircleIcon,
  BuildingLibraryIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  agencyCollectionsName,
  membershipCollectionName,
  usersCollectionName,
} from "../../../../config";
import { SankAgencyAndStaffMembershipInterface } from "../../../../interfaces/Agency.interface";
import { db, functions } from "../../../../firebase";
import { UseFormReturn } from "react-hook-form";
import { useNavigate, useLocation } from "react-router";
import { useConfirm } from "../../../../hooks/useConfirm";
import {
  AgencyStaffRole,
  UserInterface,
  UserRole,
  mapsGender,
  mapsSubRole,
  mapsUserRole,
} from "../../../../interfaces";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FormInput,
  Form,
  FormSelect,
} from "../../../../components/FormComponents";
import { classNames } from "../../../../utils";
import * as yup from "yup";
import toast from "react-hot-toast";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const userSubRole = [
  AgencyStaffRole.MANAGER,
  AgencyStaffRole.SELLER,
  UserRole.TECHNICALSUPPORT,
  AgencyStaffRole.CASHIER,
];
const userRole = [
  UserRole.AGENCYSTAFF,
  UserRole.ADMIN,
  UserRole.SUPERVISOR,
  UserRole.TECHNICALSUPPORT,
];
type SankStaffMemberMinInfos = Pick<
  UserInterface,
  "displayName" | "email" | "password" | "confirmPassword"
>;

type SankStaffMemberInfos = Pick<
  UserInterface,
  | "displayName"
  | "email"
  | "active"
  | "agence"
  | "city"
  | "adresse"
  | "cnibNumber"
  | "createdAt"
  | "gender"
  | "phoneNumber"
  | "profession"
  | "userRole"
  | "userAgencySubRole"
  | "updatedAt"
>;

type Step = {
  id: "sankStaffMemberMinInfos" | "sankStaffMemberInfos" | "sankAgencyStaff";
  index: number;
  name: string;
  description: string;
  icon: any;
};

const steps: Step[] = [
  {
    id: "sankStaffMemberMinInfos",
    index: 0,
    name: "Les informations de connexion",
    description: "Renseigner les informations de connexion du membre",
    icon: HomeIcon,
  },
  {
    id: "sankStaffMemberInfos",
    index: 1,
    name: "Les Informations du membre",
    description: "Renseigner les informations du membre",
    icon: UserCircleIcon,
  },
  {
    id: "sankAgencyStaff",
    index: 2,
    name: "Rattacher à une agence",
    description: "Rattacher le membre du staff à une agence",
    icon: BuildingLibraryIcon,
  },
];
const collectionName = usersCollectionName;

const AgencyStaffEditPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = location.state?.entity;
  const isReaffected = location.state?.isReaffected;
  const [currentFormStep, setCurrentFormStep] = useState<Step>(steps[0]);
  const [memberId, setMemberId] = useState<string>();
  const [agencyData, setAgencyData] = useState<any>();
  const [agencyIdentificationCode, setAgencyIdentificationCode] = useState("");
  const [agentStaffPhoneNumber, setAgentStaffPhoneNumber] = useState("");
  const [useRole, setUseRole] = useState<string>();
  const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

  const sankmoneyCreateSankStaffFn = functions.httpsCallable(
    "sankmoneyCreateSankStaffFn"
  );
  const sankmoneyUpdateAccountFn = functions.httpsCallable(
    "sankmoneyUpdateAccountFn"
  );
  const sankMoneyCreateMembershipFn = functions.httpsCallable(
    "sankMoneyCreateMembershipFn"
  );

  const [phoneNumberIsValid, setPhoneNumberIsValid] = useState<boolean>(false);

  const onSubmitMemberMinInfos = async (data: any) => {
    setUseRole(data.userRole);
    data.confirmPassword && delete data.confirmPassword;
    const response = sankmoneyCreateSankStaffFn({
      collectionName: collectionName,
      email: data.email,
      password: data.password,
      userRole: data.userRole,
    })
      .then((result) => {
        setMemberId(result.data.success.uid);
        setCurrentFormStep(steps[1]);
      })
      .catch((err: { details: any; message: any }) =>
        toast.error(err.details.message)
      );
    toast.promise(response, {
      error: "Une erreur s'est produite. Veuillez réessayer !",
      success: "Les informations du membre ont été enregistrer avec succès",
      loading: "chargement...",
    });
  };

  const onSubmitDefaultInfos = (data: any) => {
    if (currentUser || memberId) {
      const response = sankmoneyUpdateAccountFn({
        collectionName: collectionName,
        documentData: {
          id: memberId ? memberId : currentUser.id,
          phoneNumber: agentStaffPhoneNumber
            ? agentStaffPhoneNumber
            : currentUser?.phoneNumber,
          ...data,
        },
        documentId: memberId ? memberId : currentUser.id,
      })
        .then((result) => {
          useRole === UserRole.ADMIN
            ? navigate("/sank_staff")
            : currentUser
            ? navigate("/sank_staff")
            : useRole === UserRole.SUPERVISOR
            ? navigate("/sank_staff")
            : currentUser
            ? navigate("/sank_staff")
            : useRole === UserRole.TECHNICALSUPPORT
            ? navigate("/sank_staff")
            : setCurrentFormStep(steps[2]);
        })
        .catch((err: { details: any; message: any }) =>
          toast.error(err.details.message)
        );
      toast.promise(response, {
        error: "Une erreur s'est produite. Veuillez réessayer !",
        success: "Les informations du membre ont été enregistrer avec succès",
        loading: "chargement...",
      });
    }
  };
  const onSubmitMembershipInfos = () => {
    if (currentUser || memberId) {
      const data = {
        agencyId: agencyData && agencyData[0]?.id,
        memberId: memberId ? memberId : currentUser.id,
      };
      const response = sankMoneyCreateMembershipFn({
        collectionName: membershipCollectionName,
        documentData: data,
      })
        .then(() => {
          navigate("/sank_staff");
        })
        .catch((err: { details: any; message: any }) =>
          toast.error(err.details.message)
        );
      toast.promise(response, {
        error: "Une erreur s'est produite. Veuillez réessayer !",
        success: "L'utilisateur a été ajouter avec succès",
        loading: "chargement...",
      });
    }
  };

  const handlechange = (value: string) => {
    if (value) {
      setAgencyIdentificationCode(value);
    }
  };

  const retriveAgencyData = async () => {
    if (agencyIdentificationCode) {
      await db
        .collection(agencyCollectionsName)
        .where("identificationCode", "==", agencyIdentificationCode)
        .get()
        .then((response) => {
          setAgencyData(
            response.docs.map((d) => {
              return { id: d.id, data: d.data() };
            })
          );
        });
    }
  };

  const retrivePhoneNumber = async (phoneNumber: any) => {
    if (phoneNumber) {
      setAgentStaffPhoneNumber(phoneNumber);
    }
  };

  useEffect(() => {
    if (isReaffected) {
      currentUser && setCurrentFormStep(steps[2]);
      return;
    }
    currentUser && setCurrentFormStep(steps[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentUser) {
      (async () => {
        if (isValidPhoneNumber(currentUser.phoneNumber)) {
          const sankAccounts = await db
            .collection(usersCollectionName)
            .where("phoneNumber", "==", agentStaffPhoneNumber)
            .get();

          if (!sankAccounts.empty) {
            setPhoneNumberIsValid(true);
          }
        }
      })();
    } else {
      (async () => {
        if (isValidPhoneNumber(agentStaffPhoneNumber)) {
          const sankAccounts = await db
            .collection(usersCollectionName)
            .where("phoneNumber", "==", agentStaffPhoneNumber)
            .get();

          if (sankAccounts.empty) {
            toast.success("Le numéros de téléphone est valide.");
            setPhoneNumberIsValid(true);
          } else {
            toast.error(
              "Le numéros de téléphone renseigner est déja utiliser."
            );
            setPhoneNumberIsValid(false);
          }
        }
      })();
    }
  }, [agentStaffPhoneNumber, currentUser]);

  return (
    <>
      <div className="lg:border-t lg:border-b lg:border-gray-200">
        <nav
          className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8"
          aria-label="Progress"
        >
          <ol
            role="list"
            className="overflow-hidden rounded-md lg:flex lg:rounded-none lg:border-l lg:border-r lg:border-gray-200"
          >
            <li className="relative px-2 py-4 overflow-hidden lg:py-2">
              <button
                className="p-1 border border-transparent rounded-full hover:border-gray-200 hover:bg-gray-50"
                onClick={() => navigate("/sank_staff")}
              >
                <XMarkIcon className="w-8 h-8 text-gray-700" />
              </button>
            </li>
            {steps.map((step, stepIdx) => (
              <li key={stepIdx} className="relative overflow-hidden lg:flex-1">
                <div
                  className={classNames(
                    stepIdx === 0 ? "border-b-0 rounded-t-md" : "",
                    stepIdx === steps.length - 1
                      ? "border-t-0 rounded-b-md"
                      : "",
                    "border border-gray-200 overflow-hidden lg:border-0 h-full"
                  )}
                >
                  <button
                    className={classNames(
                      !currentUser ? "cursor-not-allowed" : "",
                      currentUser && step.index === 2 ? "" : "",
                      "w-full group h-full"
                    )}
                  >
                    <span
                      className={classNames(
                        step.index !== currentFormStep.index
                          ? "group-hover:bg-gray-200 bg-transparent "
                          : "bg-red-600",
                        "absolute top-0 left-0 w-1 h-full  lg:w-full lg:h-1 lg:bottom-0 lg:top-auto"
                      )}
                      aria-hidden="true"
                    />
                    <span
                      className={classNames(
                        stepIdx !== 0 ? "lg:pl-9" : "",
                        "px-4 py-4 lg:py-2 flex items-start text-sm font-medium"
                      )}
                    >
                      <span className="flex-shrink-0">
                        <span
                          className={classNames(
                            step.index < currentFormStep.index
                              ? "bg-red-600"
                              : "",
                            step.index === currentFormStep.index
                              ? "bg-white border-2 border-red-600"
                              : "",
                            step.index > currentFormStep.index
                              ? "bg-white border-2 border-gray-300"
                              : "",
                            "flex items-center justify-center w-10 h-10  rounded-full"
                          )}
                        >
                          <step.icon
                            className={classNames(
                              step.index < currentFormStep.index
                                ? "text-white"
                                : "",
                              step.index === currentFormStep.index
                                ? "text-red-600"
                                : "",
                              step.index > currentFormStep.index
                                ? "text-gray-500"
                                : "",
                              "w-6 h-6 "
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </span>
                      <span className="mt-0.5 ml-4 min-w-0 flex-col flex  xl:flex">
                        <span
                          className={classNames(
                            step.index === currentFormStep.index
                              ? "text-red-600"
                              : "",
                            step.index > currentFormStep.index
                              ? "text-gray-500"
                              : "",
                            "text-xs font-semibold tracking-wide uppercase md:block lg:hidden xl:block"
                          )}
                        >
                          {step.name}
                        </span>
                        <span className="flex items-start text-sm font-medium text-gray-500">
                          {step.description}
                        </span>
                      </span>
                    </span>
                  </button>
                  <div
                    className="absolute inset-0 top-0 left-0 hidden w-3 lg:block"
                    aria-hidden="true"
                  >
                    <svg
                      className="w-full h-full text-gray-300"
                      viewBox="0 0 12 82"
                      fill="none"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0.5 0V31L10.5 41L0.5 51V82"
                        stroke="currentcolor"
                        vectorEffect="non-scaling-stroke"
                      />
                    </svg>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <div className="items-center w-full mx-auto md:w-11/12 lg:w-9/12">
        {currentFormStep.id === "sankStaffMemberMinInfos" && (
          <Form<SankStaffMemberMinInfos>
            onSubmit={onSubmitMemberMinInfos}
            form={{
              resolver: yupResolver(
                yup.object().shape({
                  email: yup
                    .string()
                    .email()
                    .required("Le champs est obligatoire"),
                  userRole: yup.string().required("Le champs est obligatoire"),
                  password: yup
                    .string()
                    .required(
                      "Le mot de passe doit contenir 6 caractères minimums, 1 lettre majuscule, 1 lettre minuscule, 1 chiffre numérique."
                    )
                    .matches(
                      passwordRules,
                      "Le mot de passe doit contenir 6 caractères minimums, 1 lettre majuscule, 1 lettre minuscule, 1 chiffre numérique."
                    ),
                  confirmPassword: yup
                    .string()
                    .oneOf(
                      [yup.ref("password"), null],
                      "Les mots de passes ne sont pas compatible"
                    )
                    .required("Le champs est obligatoire"),
                })
              ),
              defaultValues: {
                email: currentUser?.email ?? "",
                password: "",
                confirmPassword: "",
              },
            }}
            submitButtonLabel={`${
              currentUser ? "Editer l'" : "Ajouter l'"
            }utilisateur`}
          >
            <div className="flex flex-col content-center w-full px-5 mt-5">
              <div className="w-full mx-auto ">
                <FormInput
                  name="email"
                  label="E-mail"
                  placeholder="@exemple.com"
                />
                <FormSelect<string>
                  options={userRole}
                  selectedOption={"Choisir..."}
                  name="userRole"
                  optionLabel={(option) =>
                    (mapsUserRole.get(option) as string) ?? "Choisir..."
                  }
                  label="Role dans l'agence"
                />
                <FormInput
                  name="password"
                  label="Mot de passe"
                  type="password"
                  placeholder="Votre mot de passe en six (06) caractères"
                  autoComplete="current-password"
                />
                <FormInput
                  type="password"
                  name="confirmPassword"
                  label="Confirmez votre mot de passe"
                  placeholder="Votre mot de passe"
                  autoComplete="current-password"
                />
              </div>
            </div>
          </Form>
        )}
        {currentFormStep.id === "sankStaffMemberInfos" && (
          <Form<SankStaffMemberInfos>
            onSubmit={onSubmitDefaultInfos}
            isSubmitBtnDisabled={!phoneNumberIsValid}
            form={{
              resolver: yupResolver(
                yup.object().shape({
                  displayName: yup
                    .string()
                    .required("Le champs est obligatoire"),
                  city: yup.string().optional(),
                  adresse: yup.string().optional(),
                  cnibNumber: yup
                    .string()
                    .required("Le champs est obligatoire"),
                  userAgencySubRole:
                    useRole && useRole === UserRole.AGENCYSTAFF
                      ? yup.string().required("Le champs est obligatoire")
                      : yup.string().optional(),
                })
              ),
              defaultValues: {
                displayName: currentUser ? currentUser.displayName : "",
                city: currentUser ? currentUser.city : "",
                adresse: currentUser ? currentUser.adresse : "",
                profession: currentUser ? currentUser.profession : "",
                cnibNumber: currentUser ? currentUser.cnibNumber : "",
                userAgencySubRole: currentUser
                  ? currentUser.userAgencySubRole
                  : "",
              },
            }}
            submitButtonLabel={`${
              currentUser ? "Enregistrer" : "Ajout un membre"
            }`}
          >
            <div className="flex flex-col content-center w-full px-5 mt-5 align-top md:flex-row">
              <div className="w-full mx-auto md:w-1/2">
                <FormInput
                  name="displayName"
                  label="Nom/Prénom"
                  placeholder="John Doe"
                />
                <PhoneInput
                  international={false}
                  placeholder="Entrer un numéro de téléphone"
                  className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:border-emerald-500 focus:outline-none sm:text-sm"
                  defaultCountry="BF"
                  value={
                    currentUser
                      ? currentUser.phoneNumber
                      : agentStaffPhoneNumber
                  }
                  onChange={retrivePhoneNumber}
                />
                <FormInput
                  name="city"
                  label="Ville"
                  optional
                  placeholder="Ouagadougou"
                />
                <FormInput
                  name="adresse"
                  optional
                  label="Adresse"
                  placeholder="Rue 10.34, secteur 30, Ouaga2000"
                />
              </div>
              <div className="w-10 h-5"></div>
              <div className="w-full mx-auto md:w-1/2">
                <FormInput
                  name="cnibNumber"
                  label="Numéro de CNIB"
                  placeholder="BXXXXXXX"
                />
                {useRole && useRole === UserRole.AGENCYSTAFF && (
                  <FormSelect<string>
                    options={userSubRole}
                    selectedOption={
                      currentUser ? currentUser.userAgencySubRole : "Choisir..."
                    }
                    name="userAgencySubRole"
                    optionLabel={(option) =>
                      (mapsSubRole.get(option) as string) ?? "Choisir..."
                    }
                    label="Role dans l'agence"
                  />
                )}

                <FormSelect<string>
                  label={"Genre"}
                  name="gender"
                  selectedOption={
                    (currentUser?.gender as string) ?? "Choisir..."
                  }
                  options={["FEMALE", "MALE", "NONBINARY", "UNKNOWN"]}
                  optionLabel={(option) =>
                    (mapsGender.get(option) as string) ?? "Choisir..."
                  }
                />
              </div>
            </div>
            {/* <EditFormFooter<SankStaffMemberInfos>
              currentStep={currentFormStep}
              hasNext={false}
              hasPrevious={false}
              steps={steps}
              onStepChanged={onSelectedStepChanged}
              setSubmitButtonRef={setSankStaffMemberInfosFormSubmitButton}
              submitBtnLabel={currentUser ? "Enregistrer" : "Créer un membre"}
              canSubmit
            /> */}
          </Form>
        )}
        {currentFormStep.id === "sankAgencyStaff" && (
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="lg:border-t lg:border-gray-200">
              <div className="items-center w-full mx-auto md:w-11/12 lg:w-9/12">
                <div className="mt-3 main-form">
                  <div className="items-center justify-between ">
                    <div className="items-center justify-between flex-1 max-w-sm">
                      <label
                        htmlFor="search"
                        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                      >
                        Rechercher
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <svg
                            className="w-4 h-4 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                            />
                          </svg>
                        </div>
                        <input
                          type="search"
                          id="search"
                          className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-red-500 focus:border-red-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-red-500 dark:focus:border-red-500"
                          placeholder="SANK23000001"
                          onChange={(e) => handlechange(e.target.value)}
                        />
                        <button
                          type="submit"
                          className="text-white absolute right-2.5 bottom-2.5 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                          onClick={() => retriveAgencyData()}
                        >
                          Rechercher
                        </button>
                      </div>
                    </div>
                    {agencyData && agencyData.length > 0 && (
                      <div className="w-full max-w-sm my-3 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                        <div className="flex flex-col items-center pb-10">
                          <img
                            className="w-24 h-24 mb-3 rounded-full shadow-lg"
                            src={
                              agencyData[0].data.profilImageUrl
                                ? agencyData[0].data.profilImageUrl
                                : `https://ui-avatars.com/api/?background=random&name=${
                                    agencyData[0].data.displayName || "S"
                                  }`
                            }
                            alt=""
                          />
                          <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white">
                            {agencyData[0].data.displayName}
                          </h5>
                          <span className="text-sm text-gray-500 dark:text-gray-400">
                            {agencyData[0].data.phoneNumber}
                          </span>
                          <div className="flex mt-4 space-x-3 md:mt-6">
                            <div
                              className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg cursor-pointer hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                              onClick={() => onSubmitMembershipInfos()}
                            >
                              Enregistrer
                            </div>
                            <div
                              className="inline-flex items-center px-4 py-2 text-sm font-medium text-center text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:ring-gray-700"
                              onClick={() => setAgencyData([])}
                            >
                              Annuler
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AgencyStaffEditPage;
